/* eslint-disable array-callback-return */

import {
  STATUS_COLOR_LIST,
  formatStatus,
  VITAL_REVERSE_LOOKUP_CODES,
  VITAL_TYPES,
  DEFAULT_BP_VALUE,
  VITAL_FHIR_CODES,
  DATE_FORMAT,
  months,
  DEFAULT_NULL_REPLACEMENT,
  DATA_SOURCE,
  CMS_CLAIMS_TYPE_TEXTS,
  BILL_STATUS_PAY_MAPPING,
  APPOINTMENT_EXTENSIONS,
  GET_DOCUMENTS_TYPE_BY_CODE,
  ConsentTypes,
  DATE_FORMAT_APPOINTMENT,
} from './constants';

const headingObject = { providersNPI: 'Providers NPI', tin: 'TIN' };

export const convertToTitleCase = value => {
  let result = value.replace(/([A-Z])/g, ' $1').split(' ');
  let result1 = result
    .map(item => item.charAt(0).toLowerCase() + item.slice(1))
    .join(' ');
  let finalResult = result1.charAt(0).toUpperCase() + result1.slice(1);
  return Object.keys(headingObject).includes(value)
    ? headingObject[value]
    : finalResult;
};

export const prescriptionTableHeading = value => {
  let result = value.split('_').join(' ');
  let finalResult = result.charAt(0).toUpperCase() + result.slice(1);
  return finalResult;
};

export const getUSFormatPhoneNo = (phoneno, oldValue = '') => {
  if (phoneno && phoneno.length < oldValue.length) {
    return phoneno;
  }

  const digits = (phoneno?.match(/\d/g) || []).join('');

  if (digits.length === 0) {
    return '';
  }
  if (digits.length <= 3) {
    return `(${digits}`;
  }
  if (digits.length <= 6) {
    return `(${digits.substr(0, 3)}) ${digits.substr(3)}`;
  }

  return `(${digits.substr(0, 3)}) ${digits.substr(3, 3)}-${digits.substr(
    6,
    4
  )}`;
};
export const getSSNFormatNo = (value, oldValue = '') => {
  if (value && value.length < oldValue.length) {
    return value;
  }
  const ssnNo = (value.match(/\d/g) || []).join('');
  if (ssnNo.length === 0) {
    return '';
  }
  if (ssnNo.length <= 3) {
    return `${ssnNo}`;
  }
  if (ssnNo.length <= 5) {
    return `${ssnNo.substr(0, 3)}-${ssnNo.substr(3, 2)}`;
  }
  return `${ssnNo.substr(0, 3)}-${ssnNo.substr(3, 2)}-${ssnNo.substr(5, 4)}`;
};

/**
 * @description : Returns Formatted Zip Code based on US postal code formats, i.e., ex : 12345 or ex: 12345-6789
 * @param {String} value
 * @param {String} oldValue
 * @returns {String}
 */
export const getZipFormatNo = (value, oldValue = '') => {
  if (value && value.length < oldValue.length) {
    return value;
  }
  const zip = (value.match(/\d/g) || []).join('');
  if (zip.length === 0) {
    return '';
  }
  if (zip.length <= 5) {
    return `${zip}`;
  }
  return `${zip.substr(0, 5)}-${zip.substr(5, 4)}`; // 12345-6789
};

export const validateSSNNo = value => {
  if (value.length !== 11) {
    return `Please enter a valid 9 digit SSN number`;
  }
  const ssnNo = (value.match(/\d/g) || []).join('');
  const first = parseInt(`${ssnNo.substr(0, 3)}`);
  const second = parseInt(`${ssnNo.substr(3, 2)}`);
  const third = parseInt(`${ssnNo.substr(5, 4)}`);
  if (
    first === 0 ||
    first === 666 ||
    second === 0 ||
    third === 0 ||
    (900 <= first && first <= 999)
  ) {
    return 'Invalid SSN Number';
  }
};
export const getTodaysDate = () => {
  var tempDate = new Date();
  var currentDate = tempDate.getFullYear() + '-';
  if (tempDate.getMonth() + 1 < 10) {
    currentDate = currentDate + '0' + (tempDate.getMonth() + 1);
  } else {
    currentDate = currentDate + (tempDate.getMonth() + 1);
  }
  currentDate = currentDate + '-';
  if (tempDate.getDate() < 10) {
    currentDate = currentDate + '0' + tempDate.getDate();
  } else {
    currentDate = currentDate + tempDate.getDate();
  }
  return currentDate;
};

/**
 * @description : Returns the affiliate name from domain
 * @returns {String}
 */
export const getAffiliateFromDomain = () => {
  if (process.env.NODE_ENV === 'development') {
    return 'affiliate1';
  } else {
    const locationHostName = window.location.hostname;
    const domainFirstHalf = locationHostName.split('.')?.[0];
    return domainFirstHalf.includes('-')
      ? domainFirstHalf.substring(0, domainFirstHalf.indexOf('-'))
      : domainFirstHalf;
  }
};

/**
 * @description : Check whether JS Object is empty
 * @param {Object} obj
 * @returns {Boolean}
 */
export const isObjectEmpty = obj => {
  return Object.keys(obj).length === 0;
};

/**
 * @description : Returns GQL Error Code
 * @param {Object} err
 * @returns {Number}
 */
export const getErrorCodeFromGQLResponse = err => {
  return err?.graphQLErrors?.[0]?.extensions?.exception?.statusCode;
};
export const validatePassword = password => {
  const passwordUpper = /[A-Z]/;
  const passwordLower = /[a-z]/;
  const passwordNumber = /[0-9]/;
  const passwordSpecialChar = /[^A-Za-z0-9]/;

  if (
    !passwordLower.test(password) ||
    !passwordNumber.test(password) ||
    !passwordUpper.test(password) ||
    !passwordSpecialChar.test(password)
  ) {
    return true;
  }
  return false;
};

export const getFormattedInputBasedOnFieldName = (fieldname, value) => {
  if (
    fieldname === 'groupnumber' ||
    fieldname === 'phonenumber' ||
    fieldname === 'ssn' ||
    fieldname === 'zipcode'
  ) {
    value = value?.replace(/[^a-zA-Z0-9]/g, '');
  }
  return value ?? null;
};

/**
 * @description : Returns Fixed Dashboard Services
 * @param {Object} items
 * @returns {Array}
 */
export const getServiceItems = (items, list) => {
  const result = [];
  for (const service in items) {
    items[service].subItems.forEach(subItem => {
      if (list.includes(subItem.category)) {
        result.push(subItem);
      }
    });
  }
  return result;
};

/**
 * @description : Returns whether given property is present in any array element
 * @param {String} property
 * @param {Array} list
 * @returns {Boolean}
 */
export const isPropertyPresentInArrayOfObjects = (property, list) => {
  return list.some(item => item.name === property);
};

/**
 * @description : Returns the object whose given property is present in any array element
 * @param {String} property
 * @param {Array} list
 * @returns {Object}
 */
export const getEquivalentObjectFromContext = (property, list) => {
  return list.find(obj => obj.name === property);
};

export const convertStrToTitleCase = str => {
  const newStr = str
    .split(' ')
    .map(w => {
      const word = w.trim();
      if (word.length > 1) {
        return word?.[0].toUpperCase() + word.substring(1).toLowerCase();
      }
      return '';
    })
    .join(' ');
  return newStr;
};

/**
 * @description : Returns the image url from subcategory array based on category provided
 * @param {String} category
 * @param {Array} list
 * @returns {String}
 */
export const getIconFromSubItemsArray = (list, category) => {
  return list.find(obj => obj.category === category)['icon'];
};

/**
 * @description : Returns the status object with color coded status
 * @param {String} statusValue
 * @param {String} color
 * @returns {Object}
 */
export const fetchStatusObj = (statusValue, color = '#FFFFFF') => {
  const formattedStatus = formatStatus(statusValue);
  const statusObj = STATUS_COLOR_LIST.find(
    obj => obj.key.toLowerCase() === formattedStatus.toLowerCase()
  );
  const res = {
    color: (statusObj && statusObj.color) || color,
    status:
      (statusObj && statusObj.key) ||
      convertStrToTitleCase(formattedStatus) ||
      '-',
  };
  return res;
};

export const statusIconColor = statusValue => {
  const formattedStatus = formatStatus(statusValue);
  const statusObj = STATUS_COLOR_LIST.find(
    obj => obj.key.toLowerCase() === formattedStatus.toLowerCase()
  );
  if (statusObj && statusObj.color) {
    return statusObj.color;
  }
  return '#FFFFFF';
};
export const displayStatusText = statusValue => {
  const formattedStatus = formatStatus(statusValue);
  const statusObj = STATUS_COLOR_LIST.find(
    obj => obj.key.toLowerCase() === formattedStatus.toLowerCase()
  );
  if (statusObj && statusObj.key) {
    return statusObj.key;
  }
  return '-';
};

export const capitalizeFirstLetter = input => {
  if (!input) {
    return '';
  }
  return input.charAt(0).toUpperCase() + input.slice(1).toLowerCase();
};

/**
 * @description : Returns Vital type
 * @param {String} coding
 * @returns {String}
 */
const findVitalType = (coding = []) => {
  const found = coding.find(item =>
    Boolean(VITAL_REVERSE_LOOKUP_CODES[item.code])
  );

  const vitalType = coding.find(item => item.code || item.display) || {};

  return (
    (found && VITAL_REVERSE_LOOKUP_CODES[found.code]) || vitalType.display || ''
  );
};

/**
 * @description : Returns an object with Blood Pressure Values
 * @param {Array} component
 * @param {String} time
 * @returns {Object}
 */
const getBPValues = (component = [], time) => {
  if (!component) {
    return {
      low: DEFAULT_BP_VALUE,
      high: DEFAULT_BP_VALUE,
      time: time,
    };
  }
  const [firstItem, secondItem] = component;
  const firstVal =
    firstItem && firstItem.valueQuantity && firstItem.valueQuantity.value;
  const secondVal =
    secondItem && secondItem.valueQuantity && secondItem.valueQuantity.value;
  const isFirstItemLow =
    firstItem &&
    firstItem.code &&
    firstItem.code.coding.length &&
    firstItem.code.coding?.[0].code &&
    firstItem.code.coding?.[0].code ===
      VITAL_FHIR_CODES.DIASTOLIC_BLOOD_PRESSURE;

  return {
    low: isFirstItemLow ? firstVal : secondVal || DEFAULT_BP_VALUE,
    high: isFirstItemLow ? secondVal : firstVal || DEFAULT_BP_VALUE,
    time,
  };
};

/**
 * @description : Replaces toReplace with replaceWith value in a string
 * @param {String} value
 * @param {String} toReplace
 * @param {String} replaceWith
 * @returns {String}
 */
export const replace = (value = '', toReplace = '', replaceWith = '') => {
  return value.replace(toReplace, replaceWith);
};

/**
 * @description : Changes Date Format
 * @param {String} date
 * @returns {String}
 */
export const dateParse = date => {
  if (!date) {
    return '-';
  }
  const resultDate = new Date(date);

  let dateInString = '';

  if (resultDate instanceof Date && !isNaN(resultDate.getTime())) {
    dateInString = replace(DATE_FORMAT, '<MMM>', months[resultDate.getMonth()]);
    dateInString = replace(dateInString, '<DD>', resultDate.getDate());
    dateInString = replace(dateInString, '<YYYY>', resultDate.getFullYear());
  }
  return dateInString;
};

/**
 * @description : Returns formatted Vitals data
 * @param {Array} vitals
 * @returns {Array}
 */
export const buildSimplifiedVitalsData = vitals => {
  const simplified = [];

  if (!vitals) {
    return simplified;
  }

  for (const vital of vitals) {
    const { collectedDate, vitalsList } = vital;
    const date = new Date(collectedDate);
    const hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();

    const time = `${hours}:${minutes}`;
    const parsedDate = dateParse(collectedDate);
    const toPush = {};

    for (const currentVital of vitalsList) {
      const {
        id,
        code: { coding },
        valueQuantity,
        valueString,
        component,
      } = currentVital;
      const vitalType = findVitalType(coding);
      const valueStringToArray = (valueString && valueString.split(':')) || [];
      const extractedValueFromString =
        valueStringToArray.length > 0 &&
        valueStringToArray?.[0].replaceAll('[', '').replaceAll(']', '');
      const extractedUnitFromString =
        valueStringToArray.length > 1 &&
        valueStringToArray[1].replaceAll('[', '').replaceAll(']', '');

      // if there are two items of same `vitalType` then use only one
      if (vitalType && !toPush[vitalType]) {
        const value =
          vitalType === VITAL_TYPES.BLOOD_PRESSURE ||
          vitalType === VITAL_TYPES.BLOOD_PRESSURE_CHILDREN
            ? getBPValues(component, time)
            : valueQuantity && valueQuantity.value;
        if (value || extractedValueFromString) {
          if (!toPush['date']) {
            toPush['date'] = parsedDate;
          }
        } else {
          continue;
        }
        const unit =
          vitalType === VITAL_TYPES.BLOOD_PRESSURE ||
          vitalType === VITAL_TYPES.BLOOD_PRESSURE_CHILDREN
            ? component &&
              component.length &&
              component?.[0].valueQuantity &&
              component?.[0].valueQuantity.unit
            : valueQuantity && valueQuantity.unit;

        const item = {
          value: value || extractedValueFromString,
          unit: unit || extractedUnitFromString || '-',
          id,
          time,
        };

        toPush[vitalType] = item;
      }
    }

    if (toPush.date) {
      simplified.push(toPush);
    }
  }
  return simplified;
};

export const handleTimeFilter = (filterVal, totalData, keyName = 'date') => {
  let data = [];
  let dif = 0;
  if (filterVal === 'all') {
    data = totalData;
    return data;
  } else if (filterVal === '6 months') {
    dif = 6 * 30 * 24 * 3600 * 1000;
  } else if (filterVal === '3 months') {
    // check time dif between the current and the record to be within 3 months
    dif = 3 * 30 * 24 * 3600 * 1000;
  } else if (filterVal === '1 month') {
    dif = 1 * 30 * 24 * 3600 * 1000;
  } else if (filterVal === '7 days') {
    dif = 7 * 24 * 3600 * 1000;
  } else if (filterVal === '15 days') {
    dif = 15 * 24 * 3600 * 1000;
  } else if (filterVal === '30 days') {
    dif = 30 * 24 * 3600 * 1000;
  }

  data = totalData.filter(obj => {
    const timeDif =
      new Date().getTime() - new Date(obj[keyName]).getTime() || 0;
    if (timeDif > 0 && timeDif <= dif) {
      return true;
    }
  });
  return data;
};
export const handleTypeFilter = (filter, dataList) => {
  let data = [];
  if (!filter) {
    return data;
  }
  const filterVal = filter && filter.toLocaleLowerCase();

  if (filterVal === 'all') {
    data = dataList;
  } else if (filterVal === 'immunizations') {
    data = data = dataList.filter(obj => {
      return obj.type.toLocaleLowerCase() === filterVal;
    });
  } else if (filterVal === 'lab results') {
    data = data = dataList.filter(obj => {
      return obj.type.toLocaleLowerCase() === filterVal;
    });
  } else if (filterVal === 'coverage') {
    data = data = dataList.filter(obj => {
      return obj.type.toLocaleLowerCase() === filterVal;
    });
  } else if (filterVal === 'conditions') {
    data = data = dataList.filter(obj => {
      return obj.type.toLocaleLowerCase() === filterVal;
    });
  } else if (filterVal === 'medications') {
    data = data = dataList.filter(obj => {
      return obj.type.toLocaleLowerCase() === filterVal;
    });
  } else if (filterVal === 'vitals') {
    data = data = dataList.filter(obj => {
      return obj.type.toLocaleLowerCase() === filterVal;
    });
  } else if (filterVal === 'allergies') {
    data = data = dataList.filter(obj => {
      return obj.type.toLocaleLowerCase() === filterVal;
    });
  } else if (filterVal === 'claims') {
    data = data = dataList.filter(obj => {
      return obj.type.toLocaleLowerCase() === filterVal;
    });
  } else if (filterVal === 'visits') {
    data = data = dataList.filter(obj => {
      return obj.type.toLocaleLowerCase() === filterVal;
    });
  } else if (filterVal === 'procedure') {
    data = data = dataList.filter(obj => {
      return obj.type.toLocaleLowerCase() === filterVal;
    });
  }

  return data;
};

export const handleStatusFilter = (filter, dataList, optionsList) => {
  let data = [];
  if (!filter) {
    return data;
  }
  const filterVal = filter && filter.toLowerCase();

  if (filterVal === 'all') {
    data = dataList;
  } else if (filterVal === 'others') {
    if (!optionsList) {
      return [];
    }
    const nonOtherList = [];
    optionsList.map(obj => {
      if (obj.value !== 'all' && obj.value !== 'others') {
        nonOtherList.push(obj.value);
      }
    });
    return dataList.filter(
      data =>
        !nonOtherList.includes(data.status ? data.status.toLowerCase() : '')
    );
  } else {
    data = dataList.filter(obj => {
      return obj.status.toLowerCase() === filterVal;
    });
  }
  return data;
};

export const handleMedicationStatusFilter = (filter, dataList, optionsList) => {
  let data = [];
  if (!filter) {
    return data;
  }
  const filterVal = filter && filter.toLowerCase();
  if (filterVal === 'all') {
    data = dataList;
  } else if (filterVal === 'inactive') {
    return dataList.filter(
      data =>
        data.status === 'inactive' ||
        data.status === 'cancelled' ||
        data.status === 'stopped' ||
        data.status === 'completed'
    );
  } else if (filterVal === 'others') {
    return dataList.filter(
      data =>
        data.status === 'on-hold' ||
        data.status === 'unknown' ||
        data.status === 'draft' ||
        data.status === 'entered-in-error'
    );
  } else {
    data = dataList.filter(obj => {
      return obj.status.toLowerCase() === filterVal;
    });
  }
  return data;
};

export const searchDataBykeys = (data, keys, text) => {
  if (keys === null || keys.length === 0 || !text || !data) return data;
  let mySet1 = new Set();
  let searchedValue = [];

  keys.map(key => {
    searchedValue = searchDataByKey(data, key, text) || [];
    if (searchedValue.length > 0) {
      for (let item of searchedValue) mySet1.add(item);
    }
  });
  let result = [];
  let i = 0;
  for (let it of mySet1) {
    result[i] = it;
    i++;
  }
  return result;
};
export const handleVisitTypeFilter = (filterVal, key, totalData) => {
  const searchedText = filterVal.toLocaleLowerCase();

  if (searchedText === 'all visits') {
    return totalData;
  }
  // eslint-disable-next-line array-callback-return

  if (searchedText === 'inpatient encounter') {
    const inpatientData = totalData.filter(obj => {
      return obj[key].toLowerCase() === 'inpatient ';
    });
    const inpatientEncounter = totalData.filter(obj => {
      return obj[key].toLowerCase().includes('inpatient encounter');
    });
    const allData = [...inpatientData, ...inpatientEncounter];
    return allData;
  }
  return totalData.filter(obj => {
    return obj[key].toLowerCase().includes(searchedText);
  });
};

export const searchDataByKey = (data, key, text) => {
  const searchedText = text.toLocaleLowerCase();
  if (data && searchedText && !key) {
    return data.filter(obj => {
      return obj.facility.toLocaleLowerCase().includes(searchedText);
    });
  }
  if (!key || !searchedText) {
    return data;
  }
  return data.filter(obj => {
    if (obj[key]) {
      return obj[key].toLocaleLowerCase().includes(searchedText);
    } else {
      return false;
    }
  });
};

/**
 * @description : Returns formatted date in MMDDYYYY format with commas
 * @param {String} dateString
 * @returns {String}
 */
export const formatDateInMMDDYYYYWithComma = dateString => {
  if (dateString) {
    const date = new Date(dateString);
    if (!date) {
      return '';
    }
    const month = months[date.getMonth()];
    const day = date.getDate();
    const year = date.getFullYear();

    return `${month} ${day}, ${year}`;
  }
  return null;
};
export const formatTimeInHHMMWithComma = dateString => {
  const date = new Date(dateString);
  if (!date) {
    return '';
  }

  var hours = date.getHours();
  var minutes = date.getMinutes();
  var ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12;
  minutes = minutes < 10 ? '0' + minutes : minutes;
  var strTime = hours + ':' + minutes + ' ' + ampm;
  return strTime;
};

/**
 * @description : Returns extracted Coding value from Array
 * @param {Array} item
 * @returns {String}
 */
export const extractValueFromCoding = item => {
  if (item) {
    return Array.isArray(item.coding) && item.coding.length
      ? item.coding?.[0].display || item.text || item.coding?.[0].code
      : item.text || null;
  }
  return item;
};

/**
 * @description : Extracts value from JSON
 * @param {Object} data
 * @param {String} key
 * @returns {String}
 */
export const extractValueFromRefDisplayJson = (data, key) => {
  if (!data || !data[key]) {
    return DEFAULT_NULL_REPLACEMENT;
  }
  const val =
    data[key].replaceAll('[', '').replaceAll(']', '') ||
    DEFAULT_NULL_REPLACEMENT;
  if (val === 'null') {
    return DEFAULT_NULL_REPLACEMENT;
  }
  return val;
};

/**
 * @description : Returns JSON from reference
 * @param {String} str
 * @returns {JSON}
 */
export const getJsonInfoFromReference = str => {
  if (!str) {
    return '';
  }
  return JSON.parse(str) || {};
};

/**
 * @description : Returns Data Source
 * @param {Arrau} identifierArray
 * @returns {String}
 */
export const findDataSource = (identifierArray = []) => {
  const systemUrlArray = [];
  let dataSource = '';
  identifierArray.forEach(obj => systemUrlArray.push(obj.system));
  if (!systemUrlArray.length) {
    return '';
  }
  const dataSourceKeys = Object.keys(DATA_SOURCE);
  identifierArray &&
    Array.isArray(identifierArray) &&
    identifierArray.forEach(obj => {
      if (obj.system && !dataSource) {
        return dataSourceKeys.forEach(partnerName => {
          if (DATA_SOURCE[partnerName].includes(obj.system)) {
            dataSource = partnerName;
          } else if (obj.system === 'data_source') {
            dataSource = obj.value;
          }
        });
      }
    });
  return dataSource;
};

/**
 * @description : Returns formatted Medications data
 * @param {Array} array
 * @returns {Array}
 */
export const formatMedicationsData = array =>
  array &&
  array.map(arrayItem => ({
    recordedOn: arrayItem.authoredOn
      ? formatDateInMMDDYYYYWithComma(arrayItem.authoredOn)
      : DEFAULT_NULL_REPLACEMENT,
    id: arrayItem.id,
    medication: `${
      arrayItem.medicationCodeableConcept?.coding[0]?.code + ' - ' ||
      DEFAULT_NULL_REPLACEMENT
    } ${
      extractValueFromCoding(arrayItem.medicationCodeableConcept) ||
      (arrayItem?.medicationReference?.display &&
        extractValueFromRefDisplayJson(
          getJsonInfoFromReference(arrayItem.medicationReference.display),
          'name'
        )) ||
      DEFAULT_NULL_REPLACEMENT
    }`,
    status: arrayItem.status || DEFAULT_NULL_REPLACEMENT,
    frequency:
      arrayItem?.dosageInstruction &&
      arrayItem?.dosageInstruction.length &&
      arrayItem?.dosageInstruction?.[0].timing &&
      arrayItem?.dosageInstruction?.[0].timing.repeat
        ? arrayItem?.dosageInstruction?.[0].timing.repeat.frequency
        : null,
    prescriber:
      arrayItem?.recorder?.display ||
      arrayItem?.performer?.[0]?.actor?.display ||
      DEFAULT_NULL_REPLACEMENT,
    pharmacy:
      (arrayItem?.encounter?.display &&
        arrayItem.encounter.display.replaceAll('[', '').replaceAll(']', '')) ||
      DEFAULT_NULL_REPLACEMENT,
    dosage:
      (arrayItem?.dosageInstruction?.[0]?.doseAndRate?.[0]?.doseQuantity &&
        `${arrayItem.dosageInstruction?.[0].doseAndRate?.[0].doseQuantity.value} ${arrayItem.dosageInstruction?.[0].doseAndRate?.[0].doseQuantity.unit}`) ||
      (arrayItem?.dosageInstruction?.length &&
        arrayItem.dosageInstruction?.[0].text) ||
      (arrayItem?.dosageInstruction?.length &&
        extractValueFromCoding(arrayItem.dosageInstruction?.[0].method)) ||
      DEFAULT_NULL_REPLACEMENT,
    dataSource:
      (arrayItem.identifier && findDataSource(arrayItem.identifier)) ||
      DEFAULT_NULL_REPLACEMENT,
    medicationType: arrayItem.__typename,
    medicationRefJsonStr:
      (arrayItem?.medicationReference?.reference &&
        arrayItem?.medicationReference?.display &&
        getJsonInfoFromReference(arrayItem.medicationReference.display)) ||
      {},
  }));

/**
 * @description : Returns Medication End Date
 * @param {String} authoredOn
 * @param {String} quantityDispensed
 * @returns {String}
 */
export const calculateMedicationEndDate = (authoredOn, quantityDispensed) => {
  if (!authoredOn) {
    return null;
  }
  if (!quantityDispensed) {
    return '';
  }
  const authoredOnTs = new Date(authoredOn).getTime();
  const dispensedDaysTs = quantityDispensed * 24 * 3600 * 1000;
  const finalTs = authoredOnTs + dispensedDaysTs;
  const endDate = formatDateInMMDDYYYYWithComma(finalTs);
  return endDate;
};

/**
 * @description : Extracts note from formatted JSON
 * @param {String} item
 * @returns {String}
 */
export const extractNote = item =>
  item && item.text
    ? item.text
    : Array.isArray(item) && item.length
    ? item?.[0].text
    : null;

let providerFiled = array => JSON.parse(array)?.provider;

export const visitsArrayConvertor = array =>
  array.map(arrayItem => ({
    id: arrayItem.id,
    recordedOn:
      (arrayItem.period &&
        arrayItem.period.start &&
        formatDateInMMDDYYYYWithComma(arrayItem.period.start)) ||
      DEFAULT_NULL_REPLACEMENT,
    facility:
      (arrayItem.serviceProvider && arrayItem.serviceProvider.display) ||
      DEFAULT_NULL_REPLACEMENT,
    typeOfVisitValue: arrayItem.class && arrayItem.class.display,
    typeOfVisitCode: arrayItem.class && arrayItem.class.code,
    typeOfVisitLabel:
      (arrayItem.class &&
        arrayItem.class.display &&
        convertStrToTitleCase(arrayItem.class.display)) ||
      DEFAULT_NULL_REPLACEMENT,
    status:
      arrayItem.status && arrayItem.status === 'onleave'
        ? 'On Leave'
        : arrayItem.status || DEFAULT_NULL_REPLACEMENT,
    provider: arrayItem?.participant?.[0]?.individual?.display
      ? providerFiled(arrayItem?.participant?.[0]?.individual?.display)
      : DEFAULT_NULL_REPLACEMENT,
    dataSource:
      (arrayItem.identifier &&
        arrayItem.identifier.length &&
        findDataSource(arrayItem.identifier)) ||
      DEFAULT_NULL_REPLACEMENT,
  }));

const draftConvertedStatus = status => {
  return status === 'DRAFT' ? 'Pending' : status;
};

export const assessmentsArrayConvertor = array =>
  array.map(arrayItem => ({
    id: arrayItem?.assessmentMeta?.id || DEFAULT_NULL_REPLACEMENT,
    assessmentName:
      arrayItem?.assessmentMeta?.assessmentName || DEFAULT_NULL_REPLACEMENT,
    expiryDate:
      formatDateInMMDDYYYYWithComma(arrayItem?.assessmentMeta?.expiryDate) ||
      DEFAULT_NULL_REPLACEMENT,
    assignedDate:
      formatDateInMMDDYYYYWithComma(arrayItem?.assessmentMeta?.assignedDate) ||
      DEFAULT_NULL_REPLACEMENT,
    numberOfQuestions:
      arrayItem?.assessmentMeta?.numberOfQuestions || DEFAULT_NULL_REPLACEMENT,
    status:
      draftConvertedStatus(arrayItem?.assessmentMeta?.status) ||
      DEFAULT_NULL_REPLACEMENT,
    orgName: arrayItem?.assessmentMeta?.orgName || DEFAULT_NULL_REPLACEMENT,
    orgImageURL:
      arrayItem?.assessmentMeta?.orgImageURL || DEFAULT_NULL_REPLACEMENT,
    assessmentInstanceId:
      // 800,
      arrayItem?.assessmentMeta?.id || DEFAULT_NULL_REPLACEMENT,
    lastAnsweredIndex: arrayItem?.assessmentResponseBody?.lastAnsweredIndex,
  }));

export const proceduresArrayConvertor = array =>
  array.map(arrayItem => ({
    recordedOn:
      (arrayItem.performedDateTime &&
        formatDateInMMDDYYYYWithComma(arrayItem.performedDateTime)) ||
      formatDateInMMDDYYYYWithComma(arrayItem.performedPeriod?.start) ||
      DEFAULT_NULL_REPLACEMENT,
    id: arrayItem.id,
    procedure: `${
      arrayItem.code?.coding?.[0].code || DEFAULT_NULL_REPLACEMENT
    } - ${extractValueFromCoding(arrayItem.code) || DEFAULT_NULL_REPLACEMENT}`,
    status: arrayItem.status || DEFAULT_NULL_REPLACEMENT,
    outcome:
      extractValueFromCoding(arrayItem.outcome) || DEFAULT_NULL_REPLACEMENT,
    dataSource:
      (arrayItem.identifier && findDataSource(arrayItem.identifier)) ||
      DEFAULT_NULL_REPLACEMENT,
    recordedBy: arrayItem.recorder?.display || DEFAULT_NULL_REPLACEMENT,
    facility:
      (arrayItem.location && arrayItem.location.display) ||
      DEFAULT_NULL_REPLACEMENT,
  }));

export const priorAuthorizationArrayConvertor = array =>
  array.map(arrayItem => ({
    id: arrayItem.id,
    name: extractValueFromCoding(arrayItem.code) || DEFAULT_NULL_REPLACEMENT,

    status: arrayItem.status || DEFAULT_NULL_REPLACEMENT,
    priority: arrayItem.priority || DEFAULT_NULL_REPLACEMENT,
    dataSource:
      (arrayItem.identifier && findDataSource(arrayItem.identifier)) ||
      DEFAULT_NULL_REPLACEMENT,

    requestDate:
      formatDateInMMDDYYYYWithComma(arrayItem.authoredOn) ||
      DEFAULT_NULL_REPLACEMENT,
    dueDate:
      formatDateInMMDDYYYYWithComma(arrayItem.occurrencePeriod?.start) ||
      DEFAULT_NULL_REPLACEMENT,
    requestingProvider:
      arrayItem.requester?.display || DEFAULT_NULL_REPLACEMENT,
  }));

export const removeTypeNameProperty = obj => {
  if (obj) {
    // this is key name  coming from backend which we dont require
    const property = '__typename';
    delete obj[property];
  }
  return obj;
};

export const removeExtraProperty = data => {
  return data.map(item =>
    Object.keys(item)
      .filter(key => key !== '__typename')
      .reduce((obj, key) => {
        obj[key] = item[key];
        return obj;
      }, {})
  );
};

export const createReactionsArray = list => {
  const res = [];

  if (Array.isArray(list) && list.length) {
    list.forEach(obj => {
      if (obj && obj.manifestation && obj.manifestation.length) {
        const value = extractValueFromCoding(obj.manifestation?.[0]);
        if (value) {
          res.push(value);
        }
      }
      if (obj && obj.description) {
        res.push(obj.description);
      }
    });

    return res.length > 0 ? res : '';
  }
  return '';
};

export const allergiesArrayConvertor = array =>
  array.map(arrayItem => ({
    recordedOn: arrayItem.recordedDate
      ? formatDateInMMDDYYYYWithComma(arrayItem.recordedDate)
      : DEFAULT_NULL_REPLACEMENT,
    allergicTo: `${
      arrayItem.code?.coding?.[0].code || DEFAULT_NULL_REPLACEMENT
    } - ${extractValueFromCoding(arrayItem.code) || DEFAULT_NULL_REPLACEMENT}`,
    id: arrayItem.id,
    status: arrayItem.clinicalStatus
      ? arrayItem.clinicalStatus.text ||
        arrayItem.clinicalStatus.coding?.[0].code ||
        DEFAULT_NULL_REPLACEMENT
      : DEFAULT_NULL_REPLACEMENT,
    criticality: arrayItem.criticality || DEFAULT_NULL_REPLACEMENT,
    recordedBy:
      arrayItem.recorder && arrayItem.recorder.display
        ? arrayItem.recorder.display
        : DEFAULT_NULL_REPLACEMENT,
    dataSource:
      (arrayItem.identifier && findDataSource(arrayItem.identifier)) ||
      DEFAULT_NULL_REPLACEMENT,
    facility:
      (arrayItem.encounter &&
        arrayItem.encounter.display &&
        arrayItem.encounter.display.replaceAll('[', '').replaceAll(']', '')) ||
      DEFAULT_NULL_REPLACEMENT,
  }));

export const formularyArrayConvertor = array =>
  array.map(arrayItem => ({
    title: arrayItem?.code?.coding
      ? arrayItem?.code?.coding?.[0]?.display ||
        arrayItem?.code?.text ||
        DEFAULT_NULL_REPLACEMENT
      : arrayItem?.code?.text || DEFAULT_NULL_REPLACEMENT,
    id: arrayItem?.id || DEFAULT_NULL_REPLACEMENT,
    sub_title: arrayItem?.manufacturer?.display || DEFAULT_NULL_REPLACEMENT,
  }));
export const coverageArrayConvertor = array =>
  array.map(arrayItem => ({
    id: arrayItem?.id || DEFAULT_NULL_REPLACEMENT,
    planId:
      arrayItem?.identifier?.[0]?.system === 'plan_id'
        ? arrayItem?.identifier?.[0]?.value
        : arrayItem?.identifier[1]?.system === 'plan_id'
        ? arrayItem?.identifier[1]?.value
        : DEFAULT_NULL_REPLACEMENT || DEFAULT_NULL_REPLACEMENT,
    coverage: arrayItem?.class?.[0]?.name || DEFAULT_NULL_REPLACEMENT,
    status: arrayItem?.status || DEFAULT_NULL_REPLACEMENT,
    startDate:
      formatDateInMMDDYYYYWithComma(arrayItem?.period?.start) ||
      DEFAULT_NULL_REPLACEMENT,
    expiryDate:
      formatDateInMMDDYYYYWithComma(arrayItem?.period?.end) ||
      DEFAULT_NULL_REPLACEMENT,
  }));

export const documentsArrayConvertor = array =>
  array.map((arrayItem, index) => ({
    key: index,
    documentName: arrayItem?.category?.[0]?.coding
      ? arrayItem?.category?.[0]?.coding?.[0]?.display ||
        arrayItem?.category?.[0]?.text ||
        DEFAULT_NULL_REPLACEMENT
      : arrayItem?.category?.[0]?.text || DEFAULT_NULL_REPLACEMENT,
    type: arrayItem?.category?.[0]?.coding
      ? GET_DOCUMENTS_TYPE_BY_CODE[
          arrayItem?.category?.[0]?.coding?.[0]?.code
        ] ||
        arrayItem?.category?.[0]?.coding?.display ||
        arrayItem?.category?.[0]?.text ||
        DEFAULT_NULL_REPLACEMENT
      : arrayItem?.category?.[0]?.coding?.display ||
        arrayItem?.category?.[0]?.text ||
        DEFAULT_NULL_REPLACEMENT,
    recordedBy: arrayItem?.author?.[0]?.display || DEFAULT_NULL_REPLACEMENT,
    facility: arrayItem?.custodian?.display || DEFAULT_NULL_REPLACEMENT,
    download: arrayItem?.content
      ? arrayItem?.content?.[0]?.attachment?.url
      : DEFAULT_NULL_REPLACEMENT,
  }));
export const carePlanArrayConvertor = array =>
  array.map(arrayItem => ({
    recordedOn:
      formatDateInMMDDYYYYWithComma(arrayItem?.created) ||
      DEFAULT_NULL_REPLACEMENT,
    id: arrayItem.id,
    careplan: arrayItem?.title || DEFAULT_NULL_REPLACEMENT,
    status: arrayItem?.status || DEFAULT_NULL_REPLACEMENT,
    recordedBy: arrayItem?.author?.display || DEFAULT_NULL_REPLACEMENT,
    facility: arrayItem?.contributor?.[0]?.display || DEFAULT_NULL_REPLACEMENT,
    manufacturer: arrayItem?.manufacturer || DEFAULT_NULL_REPLACEMENT,
    dataSource:
      (arrayItem?.identifier && findDataSource(arrayItem.identifier)) ||
      DEFAULT_NULL_REPLACEMENT,
  }));

export const consentArrayConvertor = array =>
  array.map(arrayItem => ({
    receivedOn: arrayItem.dateTime
      ? formatDateInMMDDYYYYWithComma(arrayItem.dateTime)
      : DEFAULT_NULL_REPLACEMENT,
    receivedFrom: arrayItem.sourceAttachment || DEFAULT_NULL_REPLACEMENT,
    role: arrayItem.role?.text || DEFAULT_NULL_REPLACEMENT,
    status: arrayItem.status || DEFAULT_NULL_REPLACEMENT,
    typeOfConsent: arrayItem.scope?.coding?.[0]?.display
      ? ConsentTypes[arrayItem.scope.coding?.[0].display]
      : DEFAULT_NULL_REPLACEMENT,
    expiresOn: arrayItem.provision?.dataPeriod?.end
      ? formatDateInMMDDYYYYWithComma(arrayItem.provision.dataPeriod.end)
      : DEFAULT_NULL_REPLACEMENT,
  }));

export const careTeamArrayConvertor = array =>
  array.map(arrayItem => ({
    name: arrayItem?.name || DEFAULT_NULL_REPLACEMENT,

    id: arrayItem.id,
    status: arrayItem?.status || DEFAULT_NULL_REPLACEMENT,
    category:
      arrayItem?.participant?.[0]?.role?.[0]?.coding?.[0]?.display ||
      DEFAULT_NULL_REPLACEMENT,
    contact:
      arrayItem?.participant?.[0]?.role?.[0]?.text || DEFAULT_NULL_REPLACEMENT,
  }));

export const smokingStatusArrayConvertors = array =>
  array.map(arrayItem => ({
    recordedOn: arrayItem.issued
      ? formatDateInMMDDYYYYWithComma(arrayItem.issued)
      : DEFAULT_NULL_REPLACEMENT,
    id: arrayItem.id,
    status: arrayItem.status || DEFAULT_NULL_REPLACEMENT,
    recordedBy:
      (arrayItem.performer &&
        arrayItem.performer.length &&
        arrayItem.performer?.[0].display) ||
      DEFAULT_NULL_REPLACEMENT,
    frequency:
      arrayItem.value &&
      arrayItem.value.valueQuantity &&
      arrayItem.value.valueQuantity.value
        ? arrayItem.value.valueQuantity.value
        : arrayItem.valueString
        ? arrayItem.valueString
        : arrayItem.valueQuantity && arrayItem.valueQuantity.value
        ? arrayItem.valueQuantity.value
        : DEFAULT_NULL_REPLACEMENT,
    dataSource:
      (arrayItem.identifier && findDataSource(arrayItem.identifier)) ||
      DEFAULT_NULL_REPLACEMENT,

    name: extractValueFromCoding(arrayItem.code),
    code:
      extractOnlyCodeFromCodeObj(arrayItem.code) || DEFAULT_NULL_REPLACEMENT,
  }));

export const extractLabResult = diagnosticsObject => {
  return {
    name:
      extractValueFromCoding(diagnosticsObject.code) ||
      DEFAULT_NULL_REPLACEMENT,
    code: extractOnlyCodeFromCodeObj(diagnosticsObject.code),
    id: diagnosticsObject.id,
    recordedOn: diagnosticsObject.effectiveDateTime
      ? formatDateInMMDDYYYYWithComma(diagnosticsObject.effectiveDateTime)
      : DEFAULT_NULL_REPLACEMENT,
    status: diagnosticsObject.status,
    category:
      (diagnosticsObject.category &&
        diagnosticsObject.category.length &&
        extractValueFromCoding(diagnosticsObject.category?.[0])) ||
      DEFAULT_NULL_REPLACEMENT,
    recordedBy:
      (diagnosticsObject.performer &&
        diagnosticsObject.performer.length &&
        diagnosticsObject.performer?.[0].display) ||
      DEFAULT_NULL_REPLACEMENT,
    dataSource:
      (diagnosticsObject.identifier &&
        findDataSource(diagnosticsObject.identifier)) ||
      DEFAULT_NULL_REPLACEMENT,
    facility:
      (diagnosticsObject.encounter &&
        diagnosticsObject.encounter.display &&
        diagnosticsObject.encounter.display
          .replaceAll('[', '')
          .replaceAll(']', '')) ||
      DEFAULT_NULL_REPLACEMENT,
    resultDisplay:
      diagnosticsObject.result &&
      diagnosticsObject.result.length &&
      diagnosticsObject.result?.[0].display
        ? getJsonInfoFromReference(diagnosticsObject.result?.[0].display)
        : {},
  };
};

export const diagnosticsArrayConvertor = array =>
  array.map(arrayItem => {
    const {
      id,
      name,
      code,
      recordedOn,
      status,
      category,
      recordedBy,
      resultDisplay,
      facility,
      dataSource,
    } = extractLabResult(arrayItem);
    return {
      recordedOn: recordedOn || DEFAULT_NULL_REPLACEMENT,
      id,
      name:
        name && code
          ? `${code} - ${name}`
          : code || name || DEFAULT_NULL_REPLACEMENT,
      status: status,
      category: category,
      recordedBy: recordedBy,
      dataSource: dataSource,
      facility: facility,
      resultDisplay: resultDisplay,
    };
  });

export const extractCondition = conditionObject => {
  return {
    recordedOn: conditionObject.recordedDate,
    id: conditionObject.id,
    status:
      (conditionObject.clinicalStatus && conditionObject.clinicalStatus.text) ||
      (conditionObject.clinicalStatus &&
        conditionObject.clinicalStatus.coding &&
        conditionObject.clinicalStatus.coding.length &&
        conditionObject.clinicalStatus.coding?.[0].code),
    name: extractValueFromCoding(conditionObject.code),
    code: extractOnlyCodeFromCodeObj(conditionObject.code),
    severity: extractValueFromCoding(conditionObject.severity),
    recordedBy: conditionObject.recorder
      ? conditionObject.recorder.display
      : DEFAULT_NULL_REPLACEMENT,
    dataSource:
      conditionObject.identifier && findDataSource(conditionObject.identifier),
    facility:
      conditionObject.encounter &&
      conditionObject.encounter.display &&
      conditionObject.encounter.display.replaceAll('[', '').replaceAll(']', ''),
  };
};

export const conditionsArrayConvertor = array =>
  array.map(arrayItem => {
    const {
      recordedOn,
      id,
      status,
      severity,
      dataSource,
      facility,
      name,
      recordedBy,
      code,
    } = extractCondition(arrayItem);
    return {
      recordedOn:
        (recordedOn && formatDateInMMDDYYYYWithComma(recordedOn)) ||
        DEFAULT_NULL_REPLACEMENT,
      condition:
        name && code
          ? `${code} - ${name}`
          : code || name || DEFAULT_NULL_REPLACEMENT,
      id,
      status: status || DEFAULT_NULL_REPLACEMENT,
      severity: severity || DEFAULT_NULL_REPLACEMENT,
      recordedBy: recordedBy || DEFAULT_NULL_REPLACEMENT,
      dataSource: dataSource || DEFAULT_NULL_REPLACEMENT,
      facility: facility || DEFAULT_NULL_REPLACEMENT,
    };
  });

export const extractImmunization = immunizationObject => {
  return {
    recordedOn: immunizationObject.occurrenceDateTime
      ? formatDateInMMDDYYYYWithComma(immunizationObject.occurrenceDateTime)
      : DEFAULT_NULL_REPLACEMENT,
    id: immunizationObject.id,
    status: immunizationObject.status,
    dose:
      immunizationObject.doseQuantity && immunizationObject.doseQuantity.value
        ? `${immunizationObject.doseQuantity.value}${
            immunizationObject.doseQuantity.unit
              ? immunizationObject.doseQuantity.unit
              : ''
          }`
        : immunizationObject.doseQuantity &&
          immunizationObject.doseQuantity.code,
    recordedBy:
      immunizationObject.performer &&
      immunizationObject.performer.length &&
      immunizationObject.performer?.[0].actor &&
      immunizationObject.performer?.[0].actor.display,

    facility:
      (immunizationObject.location && immunizationObject.location.display) ||
      (immunizationObject.encounter && immunizationObject.encounter.display),

    manufacturer: immunizationObject.manufacturer,
    dataSource:
      immunizationObject.identifier &&
      findDataSource(immunizationObject.identifier),
    name: extractValueFromCoding(immunizationObject.vaccineCode),
    code: extractOnlyCodeFromCodeObj(immunizationObject.vaccineCode),
  };
};

export const immunizationsArrayConvertor = array =>
  array.map(arrayItem => {
    const {
      id,
      recordedOn,
      name,
      code,
      status,
      dose,
      dataSource,
      recordedBy,
      manufacturer,
      facility,
    } = extractImmunization(arrayItem);
    return {
      recordedOn: recordedOn
        ? formatDateInMMDDYYYYWithComma(recordedOn)
        : DEFAULT_NULL_REPLACEMENT,
      id,
      immunization:
        name && code
          ? `${code} - ${name}`
          : code || name || DEFAULT_NULL_REPLACEMENT,
      status: status || DEFAULT_NULL_REPLACEMENT,
      dose: dose || DEFAULT_NULL_REPLACEMENT,
      recordedBy: recordedBy || DEFAULT_NULL_REPLACEMENT,
      facility: facility || DEFAULT_NULL_REPLACEMENT,
      manufacturer: manufacturer || DEFAULT_NULL_REPLACEMENT,
      dataSource:
        (dataSource && findDataSource(dataSource)) || DEFAULT_NULL_REPLACEMENT,
    };
  });

export const fixFormat = date => {
  if (!date) {
    return '';
  }
  return date;
};

export const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sept',
  'Oct',
  'Nov',
  'Dec',
];

export const dateParseV2 = date => {
  if (!date) {
    return null;
  }

  const newDate = fixFormat(date);
  const resultDate = new Date(newDate);
  const day = `0${resultDate.getUTCDate()}`.slice(-2);

  if (resultDate instanceof Date && !isNaN(resultDate.getTime())) {
    return `${
      MONTHS[resultDate.getUTCMonth()]
    } ${day}, ${resultDate.getUTCFullYear()}`;
  }
  return DEFAULT_NULL_REPLACEMENT;
};

export const formatClaimsData = array =>
  array &&
  array.map(arrayItem => {
    return {
      id: arrayItem.id,
      claimType: arrayItem.claimType || DEFAULT_NULL_REPLACEMENT,
      claimTypeLabel:
        (arrayItem.claimType && CMS_CLAIMS_TYPE_TEXTS[arrayItem.claimType]) ||
        DEFAULT_NULL_REPLACEMENT,
      recordedOn:
        (arrayItem.created &&
          formatDateInMMDDYYYYWithComma(arrayItem.created)) ||
        DEFAULT_NULL_REPLACEMENT,
      dataSource:
        (arrayItem.identifier && findDataSource(arrayItem.identifier)) ||
        DEFAULT_NULL_REPLACEMENT,
      claimNumber:
        (arrayItem.identifier && arrayItem.identifier?.[0].value) ||
        DEFAULT_NULL_REPLACEMENT,
      status: arrayItem.status || DEFAULT_NULL_REPLACEMENT,
      provider:
        (arrayItem.provider && arrayItem.provider.display) ||
        DEFAULT_NULL_REPLACEMENT,
      claimAmount:
        arrayItem.claimAmount !== null &&
        arrayItem.claimAmount !== '' &&
        arrayItem.claimAmount !== undefined
          ? '$' + arrayItem.claimAmount
          : arrayItem.claimAmountMedicare !== null &&
            arrayItem.claimAmountMedicare !== '' &&
            arrayItem.claimAmountMedicare !== undefined
          ? '$' + arrayItem.claimAmountMedicare
          : DEFAULT_NULL_REPLACEMENT,
    };
  });

export const formatCost = costValue => {
  if (costValue) {
    return `$${costValue}`;
  }
  return '-';
};

export const handleclaimsTypeFilter = (filterVal, totalData) => {
  let data = [];
  if (filterVal.toLowerCase() === 'all') {
    data = totalData;
    return data;
  }
  const claimLabel = CMS_CLAIMS_TYPE_TEXTS[filterVal];
  data = totalData.filter(obj => {
    if (claimLabel === CMS_CLAIMS_TYPE_TEXTS['CARRIER']) {
      // professional services
      return obj.claimType === 'CARRIER' || obj.claimType === 'professional';
    }
    return obj.claimType === filterVal;
  });

  return data;
};

export const filterByVitalType = (vitalType, items, optionsList) => {
  if (vitalType === 'ALL') {
    return items;
  } else if (vitalType === 'others') {
    if (!optionsList) {
      return [];
    }
    const nonOtherList = [];
    optionsList.map(obj => {
      if (obj.value !== 'All' && obj.value !== 'others') {
        nonOtherList.push(obj.value);
      }
    });

    const newItems = items.map(data => {
      const newData = { ...data };
      delete newData.date;
      const keys = Object.keys(newData);
      keys.forEach(val => {
        if (nonOtherList.includes(val)) {
          delete newData[val];
        }
      });
      if (Object.keys(newData).length > 0) {
        newData.date = data.date;
      }
      return newData;
    });

    const returnItems = newItems.filter(obj => Object.keys(obj).length);

    return returnItems;
  }

  const filtered = [];

  for (const item of items) {
    const matched = item[vitalType];

    if (matched) {
      filtered.push({
        date: item.date,
        [vitalType]: matched,
      });
    }
  }

  return filtered;
};

const getPayOptionValue = (status, isDue) => {
  if (!status) {
    return '-';
  }
  if (status.toLowerCase() === 'issued' && isDue) {
    return true;
  }
  return BILL_STATUS_PAY_MAPPING[status.toLowerCase()];
};

export const arrangeBillsData = (data, isDue) => {
  return {
    id: data.billId || DEFAULT_NULL_REPLACEMENT,
    copayAmount: data?.copayAmount || DEFAULT_NULL_REPLACEMENT,
    recordedOn: dateParse(data.date) || DEFAULT_NULL_REPLACEMENT,
    facility: data.providerName || DEFAULT_NULL_REPLACEMENT,
    amount: '$' + data.totalDue || DEFAULT_NULL_REPLACEMENT,
    status:
      data.status && data.status.toLowerCase() === 'enteredinerror'
        ? 'Entered In Error'
        : data.status || DEFAULT_NULL_REPLACEMENT,
    paymentStatus: data.paymentStatus,
    pay: getPayOptionValue(data.status, isDue),
    dataSource: 'Claims',
    providerName: data.providerName || DEFAULT_NULL_REPLACEMENT,
    serviceType: data.serviceType || DEFAULT_NULL_REPLACEMENT,
    totalDue: data.totalDue || DEFAULT_NULL_REPLACEMENT,
    promoCode: data?.promoCodeAmount || DEFAULT_NULL_REPLACEMENT,
    paidAmount: data?.paidAmount || DEFAULT_NULL_REPLACEMENT,
    paidByPlanAmount: data?.paidByPlanAmount || DEFAULT_NULL_REPLACEMENT,
  };
};

/**
 * @description : Returns black or white based on background color contrast
 * @param {String} hexcolor
 * @returns {String}
 */
export const getContrastYIQ = hexcolor => {
  if (!hexcolor.startsWith('#')) {
    return 'white';
  }
  hexcolor = hexcolor.replace('#', '');
  var r = parseInt(hexcolor.substr(0, 2), 16);
  var g = parseInt(hexcolor.substr(2, 2), 16);
  var b = parseInt(hexcolor.substr(4, 2), 16);
  var yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 128 ? 'black' : 'white';
};

/**
 * @description : Extracts valueString from extensions for provided url
 * @param {Array} extension
 * @param {String} url
 * @returns {String}
 */
export const getValueFromExtension = (extension = [], url) => {
  return extension?.find(obj => obj.url === url).valueString;
};

/**
 * @description : Extracts Time in AM/PM from date object
 * @param {Date} date
 * @returns {String}
 */
export const formatAMPM = date => {
  let hours = date.getHours();
  let minutes = date.getMinutes();
  var ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? '0' + minutes : minutes;
  const strTime = hours + ':' + minutes + ' ' + ampm;
  return strTime;
};

/**
 * @description : Formats ISO Date and returns it in weekday day, Month format
 * @param {String} date
 * @returns {String}
 */
export const formatISODate = date =>
  new Date(date).toLocaleString('default', {
    weekday: 'short',
    month: 'long',
    day: 'numeric',
  });

export const formatAppointments = array =>
  array?.map(arrayItem => ({
    id: arrayItem.id,
    recordedOn:
      formatDateInMMDDYYYYWithComma(arrayItem?.created) ??
      DEFAULT_NULL_REPLACEMENT,
    time: formatAMPM(new Date(arrayItem?.start)) ?? DEFAULT_NULL_REPLACEMENT,
    dateTime: `${formatISODate(arrayItem?.start)}, ${formatAMPM(
      new Date(arrayItem?.start)
    )}`,
    //facility: arrayItem.facility,  Commented temporarily
    typeOfVisitValue:
      getValueFromExtension(
        arrayItem?.extension,
        APPOINTMENT_EXTENSIONS.VISIT_TYPE
      ) ?? DEFAULT_NULL_REPLACEMENT,
    status: arrayItem?.status ?? DEFAULT_NULL_REPLACEMENT,
    provider:
      arrayItem?.participant?.actor?.display ?? DEFAULT_NULL_REPLACEMENT,
  }));

export const getMedicalHistoryDataFromExtensions = extension => {
  const medicalHistoryData = [];
  medicalHistoryData.push(
    {
      condition: 'Smoking',
      value: getValueFromExtension(
        extension,
        APPOINTMENT_EXTENSIONS.SMOKING_VALUE
      ),
      description: getValueFromExtension(
        extension,
        APPOINTMENT_EXTENSIONS.SMOKING_FREQUENCY
      ),
    },
    {
      condition: 'Drinking',
      value: getValueFromExtension(
        extension,
        APPOINTMENT_EXTENSIONS.ALCOHOL_VALUE
      ),
      description: getValueFromExtension(
        extension,
        APPOINTMENT_EXTENSIONS.ALCOHOL_FREQUENCY
      ),
    },
    {
      condition: 'Recreational Drugs',
      value: getValueFromExtension(
        extension,
        APPOINTMENT_EXTENSIONS.RECREATIONAL_VALUE
      ),
      description: getValueFromExtension(
        extension,
        APPOINTMENT_EXTENSIONS.RECREATIONAL_FREQUENCY
      ),
    }
  );
  return medicalHistoryData;
};

const policyHolderName = array => JSON.parse(array)['contact-name'];

export const plancoverageArrayConvertor = array =>
  array.map(arrayItem => ({
    startDate:
      (arrayItem.period &&
        arrayItem.period.start &&
        formatDateInMMDDYYYYWithComma(arrayItem.period.start)) ||
      DEFAULT_NULL_REPLACEMENT,
    endDate:
      (arrayItem.period &&
        arrayItem.period.end &&
        formatDateInMMDDYYYYWithComma(arrayItem.period.end)) ||
      DEFAULT_NULL_REPLACEMENT,
    policyNumber: arrayItem.identifier[0].value || DEFAULT_NULL_REPLACEMENT,
    planName: arrayItem?.class?.[0]?.name || DEFAULT_NULL_REPLACEMENT,
    primaryInsure:
      policyHolderName(arrayItem.policyHolder.display) ||
      DEFAULT_NULL_REPLACEMENT,
  }));

const getName = arrName => {
  const fullName = {
    initialName: '',
    familyName: '',
  };

  arrName?.map(obj => {
    if (obj.family) {
      fullName.familyName = obj.family;
    }
    if (obj.given instanceof Array) {
      const totalGivenName = obj.given.map(obj => obj);
      fullName.initialName = totalGivenName?.[0];
    }
  });
  return `${fullName.initialName} ${fullName.familyName}` || '';
};

export const providersArrayConvertor = array =>
  array.map(arrayItem => ({
    id: arrayItem.id,
    //name: arrayItem.name
    //? getName(arrayItem.name)
    //: null || DEFAULT_NULL_REPLACEMENT,
    name: arrayItem.name?.[0].text || DEFAULT_NULL_REPLACEMENT,
    telecom: arrayItem.telecom?.[0].value || DEFAULT_NULL_REPLACEMENT,
    qualification:
      arrayItem?.qualification?.[0]?.code.text || DEFAULT_NULL_REPLACEMENT,
    communication:
      arrayItem?.communication?.[0]?.text || DEFAULT_NULL_REPLACEMENT,
    speciality:
      arrayItem?.extension?.[0]?.valueString || DEFAULT_NULL_REPLACEMENT,
    rating: DEFAULT_NULL_REPLACEMENT,
    acceptingPatient: arrayItem.active || DEFAULT_NULL_REPLACEMENT,
    distance: DEFAULT_NULL_REPLACEMENT,
  }));

export const handlespecialityFilters = (filter, dataList) => {
  let data = [];
  if (!filter) {
    return data;
  }
  const filterVal = filter && filter.toLocaleLowerCase();
  if (filterVal === 'all') {
    data = dataList;
  }

  if (filterVal === 'speciality') {
    data = data = dataList.filter(obj => {
      return obj.speciality.toLocaleLowerCase() === filterVal;
    });
  }
  return data;
};
export const handlespecialityFilter = (filterVal, key, totalData) => {
  const searchedText = filterVal.toLocaleLowerCase();

  if (searchedText === 'all') {
    return totalData;
  }
  // eslint-disable-next-line array-callback-return
  return totalData.filter(obj => {
    if (obj[key]) {
      return obj[key].toLowerCase().includes(searchedText);
    }
  });
};

export const handlelanguageFilter = (filterVal, key, totalData) => {
  const searchedText = filterVal.toLocaleLowerCase();

  if (searchedText === 'all') {
    return totalData;
  }
  // eslint-disable-next-line array-callback-return
  return totalData.filter(obj => {
    if (obj[key]) {
      return obj[key].toLowerCase().includes(searchedText);
    }
  });
};

export const handleboardFilter = (filter, dataList, optionsList) => {
  let data = [];
  if (!filter) {
    return data;
  }
  const filterVal = filter && filter.toLowerCase();
  if (filterVal === 'all') {
    data = dataList;
  }
  return data;
};

const previouslyVisitedarray = array => JSON.parse(array).avatar;
const providerField = array => JSON.parse(array).provider;
const specialityField = array => JSON.parse(array)?.speciality;
const practitionerfiledid = array => JSON.parse(array)?.practitionerId;

export const previouslyVisitedArrayConvertor = array =>
  array.map(arrayItem => ({
    avatar: arrayItem?.participant?.[0]?.individual.display
      ? previouslyVisitedarray(arrayItem?.participant?.[0]?.individual.display)
      : DEFAULT_NULL_REPLACEMENT,
    provider: arrayItem?.participant?.[0]?.individual.display
      ? providerField(arrayItem?.participant?.[0]?.individual.display)
      : null || DEFAULT_NULL_REPLACEMENT,
    speciality: arrayItem?.participant?.[0]?.individual.display
      ? specialityField(arrayItem?.participant?.[0]?.individual.display)
      : null || DEFAULT_NULL_REPLACEMENT,
    id: arrayItem?.participant?.[0]?.individual.display
      ? practitionerfiledid(arrayItem?.participant?.[0]?.individual.display)
      : null || DEFAULT_NULL_REPLACEMENT,
  }));

export const handletypeFilter = (filter, dataList) => {
  let data = [];
  if (!filter) {
    return data;
  }
  const filterVal = filter && filter.toLocaleLowerCase();
  if (filterVal === 'all') {
    data = dataList;
  }
  if (filterVal === 'Retail Pharmacy') {
    data = data = dataList.filter(obj => {
      return obj.type.toLocaleLowerCase() === filterVal;
    });
  }
  return data;
};

/**
 * @description : The download function takes a CSV string, the filename and mimeType as parameters
 * @param {String} content
 * @param {String} fileName
 * @param {String} mimeType
 */
export const DownloadFile = (content, fileName, mimeType) => {
  var a = document.createElement('a');
  mimeType = mimeType || 'application/octet-stream';

  if (navigator.msSaveBlob) {
    // IE10
    navigator.msSaveBlob(
      new Blob([content], {
        type: mimeType,
      }),
      fileName
    );
  } else if (URL && 'download' in a) {
    //html5 A[download]
    a.href = URL.createObjectURL(
      new Blob([content], {
        type: mimeType,
      })
    );
    a.setAttribute('download', fileName);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  } else {
    window.location.href =
      'data:application/octet-stream,' + encodeURIComponent(content); // only this mime type is supported
  }
};

const payerArray = [
  'advent-qa-member.mpoweredhealth.com',
  'cigna-member.mpoweredhealth.com',
];

export const DownloadRawFile = (link, payerUrl) => {
  let a = document.createElement('a');
  a.href = link;
  if (payerArray.includes(payerUrl)) {
    a.setAttribute('target', '_blank');
  } else {
    a.setAttribute('download', 'PriceTransparency');
  }
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

export const handleTypeFilterType = (filter, dataList) => {
  let data = [];
  if (!filter) {
    return data;
  }
  const filterVal = filter && filter.toLocaleLowerCase();
  if (filterVal === 'all') {
    data = dataList;
  } else {
    data = dataList.filter(obj => {
      return obj.type?.toLocaleLowerCase() === filterVal;
    });
  }
  return data;
};

export const handleratingFilter = (filterVal, key, totalData) => {
  const searchedText = filterVal.toLocaleLowerCase();

  if (searchedText === 'all') {
    return totalData;
  }
  // eslint-disable-next-line array-callback-return
  return totalData.filter(obj => {
    if (obj[key]) {
      return obj[key].toLowerCase().includes(searchedText);
    }
  });
};

export const redirectionData = item => {
  if (item === '/care/carePlans') {
    return 'Diabetes Care Plan';
  } else if (item === '/care/assessments') {
    return 'Health risk assessment';
  } else if (item === '/care/appointments') {
    return 'booked';
  }
};

export const pharmacyArrayConvertor = array =>
  array.map(arrayItem => ({
    id: arrayItem.id,
    address: `${arrayItem.address?.[0]?.postalCode}, ${arrayItem.address?.[0]?.text}`,
    pharmacyName: arrayItem.name,
    type: arrayItem?.type?.[0]?.coding?.[0]?.code,
    phoneNumber: arrayItem?.telecom?.[0]?.value,
    fax: arrayItem?.telecom?.[1]?.value,
  }));

export const dateParse_appointment = date => {
  if (!date) {
    return '-';
  }
  const resultDate = new Date(date);

  let dateInString = '';

  if (resultDate instanceof Date && !isNaN(resultDate.getTime())) {
    dateInString = replace(
      DATE_FORMAT_APPOINTMENT,
      '<MMM>',
      months[resultDate.getMonth()]
    );
    dateInString = replace(dateInString, '<DD>', resultDate.getDate());
    dateInString = replace(dateInString, '<YYYY>', resultDate.getFullYear());
  }
  return dateInString;
};

const getAmPm = time => {
  let amPmStatus = '';
  if (time >= 9 && time < 12) {
    amPmStatus = 'AM';
  } else {
    amPmStatus = 'PM';
  }
  return amPmStatus;
};

const TimeSlot = array => {
  const newTime = array.slice(11, 19);
  const time = `${newTime} ${getAmPm(Number(newTime.slice(0, 2)))}`;
  return time;
};

const TimeStatus = timeArr => {
  const newTime = Number(timeArr?.slice(11, 13));
  return newTime;
};
export const TimeSlotArrayConvertor = array => {
  let morning = [];
  let afternoon = [];
  let evening = [];

  const allTimeSlots = array?.map((arrayItem, i) => ({
    id: arrayItem.id,
    startTime: TimeSlot(arrayItem.startDate),
    endTime: TimeSlot(arrayItem.endDate),
    timeStatus: TimeStatus(arrayItem.startDate),
    status: arrayItem.status,
  }));

  allTimeSlots?.map((time, i) => {
    if (time.timeStatus < 12 && time.timeStatus >= 9) {
      morning.push(time);
    } else if (time.timeStatus < 17 && time.timeStatus >= 12) {
      afternoon.push(time);
    } else {
      evening.push(time);
    }
  });
  allTimeSlots.morning = morning;
  allTimeSlots.afternoon = afternoon;
  allTimeSlots.evening = evening;

  return allTimeSlots;
};

export const extractOnlyCodeFromCodeObj = item => {
  if (item) {
    return Array.isArray(item.coding) && item.coding.length
      ? item.coding?.[0].code
      : null;
  }
  return item;
};

export const socialHistoryArrayConverter = array =>
  array.map(arrayItem => {
    const {
      id,
      recordedOn,
      status,
      recordedBy,
      frequency,
      dataSource,
      code,
      name,
    } = extractSocialHistory(arrayItem);
    return {
      recordedOn:
        (recordedOn && formatDateInMMDDYYYYWithComma(recordedOn)) ||
        DEFAULT_NULL_REPLACEMENT,
      id,
      status: status || DEFAULT_NULL_REPLACEMENT,
      recordedBy: recordedBy || DEFAULT_NULL_REPLACEMENT,
      frequency: frequency || DEFAULT_NULL_REPLACEMENT,
      dataSource: dataSource || DEFAULT_NULL_REPLACEMENT,
      name:
        name && code
          ? `${code} - ${name}`
          : code || name || DEFAULT_NULL_REPLACEMENT,
      code: code || DEFAULT_NULL_REPLACEMENT,
    };
  });

export const extractSocialHistory = socialHistoryObject => {
  return {
    recordedOn: socialHistoryObject.issued,
    id: socialHistoryObject.id,
    status: socialHistoryObject.status,
    recordedBy:
      socialHistoryObject.performer &&
      socialHistoryObject.performer.length &&
      socialHistoryObject.performer?.[0].display,
    frequency:
      socialHistoryObject.valueQuantity &&
      socialHistoryObject.valueQuantity.value
        ? socialHistoryObject.valueQuantity.value +
          ' ' +
          socialHistoryObject.valueQuantity.unit
        : socialHistoryObject.valueCodeableConcept &&
          socialHistoryObject.valueCodeableConcept.coding &&
          socialHistoryObject.valueCodeableConcept.coding?.[0] &&
          socialHistoryObject.valueCodeableConcept.coding?.[0].display
        ? socialHistoryObject.valueCodeableConcept.coding?.[0].display
        : socialHistoryObject.valueCodeableConcept &&
          socialHistoryObject.valueCodeableConcept.text
        ? socialHistoryObject.valueCodeableConcept.text
        : socialHistoryObject.valueString
        ? socialHistoryObject.valueString
        : socialHistoryObject.valueBoolean
        ? socialHistoryObject.valueBoolean
        : socialHistoryObject.valueInteger
        ? socialHistoryObject.valueInteger
        : socialHistoryObject.valueRange
        ? socialHistoryObject.valueRange
        : socialHistoryObject.valueRatio
        ? socialHistoryObject.valueRatio
        : socialHistoryObject.valueSampledData
        ? socialHistoryObject.valueSampledData
        : socialHistoryObject.valueTime
        ? socialHistoryObject.valueTime
        : socialHistoryObject.valueDateTime
        ? socialHistoryObject.valueDateTime
        : socialHistoryObject.valuePeriod
        ? socialHistoryObject.valuePeriod
        : DEFAULT_NULL_REPLACEMENT,
    dataSource:
      socialHistoryObject.identifier &&
      findDataSource(socialHistoryObject.identifier),
    name: extractValueFromCoding(socialHistoryObject.code),
    code: extractOnlyCodeFromCodeObj(socialHistoryObject.code),
  };
};

export const getStatusFilterParamList = (
  filterVal,
  dropdownList,
  completeList = []
) => {
  if (!filterVal || !dropdownList || filterVal === 'all') {
    return '';
  }

  if (filterVal === 'others') {
    const otherList = completeList.filter(item => {
      return !dropdownList.find(
        obj => obj && obj.value.toLowerCase() === item.toLowerCase()
      );
    });
    if (!otherList.includes('unknown')) {
      otherList.push('unknown');
    }
    return otherList.toString();
  }

  const filterMapping = dropdownList.find(
    obj => obj.value.toLowerCase() === filterVal.toLowerCase()
  ).mappingList;
  if (filterMapping) {
    return filterMapping.toString();
  }

  return filterVal;
};

export const PROCEDURE_STATUS_LIST = [
  'preparation',
  'in-progress',
  'not-done',
  'on-hold',
  'stopped',
  'completed',
  'entered-in-error',
  'unknown',
];

export const LAB_RESULT_STATUS_LIST = [
  'registered',
  'partial',
  'preliminary',
  'final',
  'amended',
  'appended',
  'corrected',
  'cancelled',
  'entered-in-error',
  'unknown',
];

export const calculateDateFilterTimeStamp = (filterVal, custom_date = '') => {
  let finalDate = new Date();
  switch (filterVal.toLowerCase()) {
    case 'all':
      finalDate = 0;
      return 0;
    case '1 month':
    case '1m':
      finalDate = new Date(finalDate.setMonth(finalDate.getMonth() - 1));
      break;
    case '3 months':
    case '3m':
      finalDate = new Date(finalDate.setMonth(finalDate.getMonth() - 3));
      break;
    case '6 months':
    case '6m':
      finalDate = new Date(finalDate.setMonth(finalDate.getMonth() - 6));
      break;
    case 'custom_date':
      finalDate = new Date(custom_date);
      break;
    default:
      break;
  }
  return finalDate.getTime();
};
